import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { RouterOutlet, Router, ActivatedRoute, RouterLink } from '@angular/router';
import { ShamShamLogoFullIcon } from 'sham-components/icons';
import { SellerSignupManager } from './seller-signup-manager';
import { CommonModule } from '@angular/common';
import { PersonalInfoStep } from './steps/personal-info-step/personal-info-step';
import { CompanyInfoStep } from './steps/company-info-step/company-info-step';
import { StoreProfileStep } from './steps/store-profile-step/store-profile-step';

@Component({
  selector: 'app-seller-signup',

  imports: [RouterOutlet, ShamShamLogoFullIcon, CommonModule, RouterLink],
  templateUrl: './seller-signup.html',
})
export class SellerSignupComponent implements OnInit {
  readonly manager = inject(SellerSignupManager);

  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  @ViewChild(PersonalInfoStep) personal!: PersonalInfoStep;
  @ViewChild(CompanyInfoStep) company!: CompanyInfoStep;
  @ViewChild(StoreProfileStep) store!: StoreProfileStep;

  ngOnInit(): void {
    this.manager.loadApplication();
  }

  isActiveRoute(part: string): boolean {
    return this.router.url.includes(part);
  }
}
